import React, { useContext } from 'react';
import { ThemeConfigContext } from './ThemeConfigProvider';

const useThemeWithPartner = () => {
    const context = useContext(ThemeConfigContext);

    return {
        name: context.name,
    };
};

export default useThemeWithPartner;
